import './YandexBanner.css';

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-undef */
import React from 'react';
import { useRouter } from '@search/offer-search-routes/src';
import classname from '@search/classname/src';
import { addScript } from '../addScript';
const cn = classname.bind(null, 'YandexBanner');

type YandexBannerContext = Function[];
type YAContext = {
    adfoxCode: {
        create(src: Object): void;
    };
    Context: {
        AdvManager: {
            render(args: Object): void;
        };
    };
}

async function yandexBannerInit({
    containerId,
    blockId
}: { blockId: string; containerId: string }) {
    await addScript({
        content: '',
        src: 'https://yandex.ru/ads/system/context.js',
        id: 'yabanner-01',
        check: () => Boolean((window as Window & {yaContextCb?: YandexBannerContext}).yaContextCb)
    });

    const yaContextCb = (window as unknown as Window & {yaContextCb: YandexBannerContext}).yaContextCb;

    yaContextCb.push(() => {
        const Ya = (window as unknown as Window & {Ya: YAContext}).Ya;

        Ya.Context.AdvManager.render({
            renderTo: containerId,
            blockId
        });
    });
}

const variants = {
    'offer-similar-mob': { // Карточка, перед похожими в мобилке
        width: 336,
        height: 280,
        id: 'R-A-1950727-8',
        left: false
    },
    'offer-breadcrumb-mob': { // Карточка под бредкрамбами, мобилка
        width: 336,
        height: 280,
        id: null,
        left: false
    },
    'offer-address-mob': { // Карточка под адресом, моб
        width: 320,
        height: 50,
        id: 'R-A-1950727-7',
        left: false
    },
    'search-mob': { // серп, моб
        width: 320,
        height: 100,
        id: 'R-A-1950727-6',
        left: false
    },
    'offer-sidebar-desk': { // карточка, сайдбар справа под кнопками, деск
        width: 240,
        height: 400,
        id: 'R-A-1950727-5',
        left: true
    },
    'offer-map-desk': { // карточка, под картой, деск
        width: 728,
        height: 90,
        id: 'R-A-1950727-2',
        left: true
    },
    'offer-footer-desk': { // карточка, футер, деск
        width: 1000,
        height: 120,
        id: 'R-A-1950727-4',
        left: false
    },
    'search-desk': { // серп, деск
        width: 1000,
        height: 120,
        id: 'R-A-1950727-3',
        left: false
    }
} as const;

export function YandexBanner({
    variant
}: { variant: keyof typeof variants }) {
    const rec = variants[variant];

    const containerId = rec?.id ? `yandex_rtb_${rec.id}` : null;
    const blockId = rec?.id;

    const router = useRouter();
    const hilite = router.currentUrl.includes('dbg_yaban_hilite=1');

    React.useEffect(() => {
        if (! containerId || ! blockId) return;

        yandexBannerInit({ containerId, blockId }).then(() => {}, () => {});
    }, [ containerId, blockId ]);

    if (! containerId) return null;

    return (<div
        className={cn(null, { left: rec.left })}
    >
        <div
            className={hilite ? cn('hilite') : undefined}
            style={{ width: rec.width, height: rec.height }}
            id={containerId ?? ''}
        ></div>
    </div>);
}
